export default __webpack_public_path__ + "static/media/travelnerd-thumbnail.6cad9745.jpg";